export default {
  name: "MenuItem",
  props: {
    path: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    altText: {
      type: String,
      required: false
    },
    caption: {
      type: String,
      required: true
    },
    iconColor: {
      type: String,
      required: true
    },
    hoverColor: {
      type: String,
      required: true
    }
  }
};